import { render } from "./BackToSaleButton.vue?vue&type=template&id=0a2f5b83&scoped=true"
import script from "./BackToSaleButton.vue?vue&type=script&lang=js"
export * from "./BackToSaleButton.vue?vue&type=script&lang=js"

import "./BackToSaleButton.vue?vue&type=style&index=0&id=0a2f5b83&scoped=true&lang=css"

import exportComponent from "/Users/remy/Sites/baghera/WocUp/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2f5b83"]])

export default __exports__